import { ref } from "@vue/reactivity";
import NavBar from "@/view/components/nav-bar/nav-bar";
import { closeToast, showLoadingToast } from "vant";
import axios from "axios";
import config from "@/config";
import SessionUtil from "@/utils/SessionUtil";
import StorageUtil from "@/utils/StorageUtil";
import SettingApi from "@/api/setting-api";
export default {
  name: "RidePreference",
  components: {
    NavBar
  },
  setup() {
    const title = ref("乘车偏好");
    const setting = ref(SettingApi.getDefaultConfig());
    const isWatchSetting = ref(false);
    const showVehicleTypes = ref(false);
    const showWaitingTimeout = ref(false);
    const vehicleTypes = ref({
      "ORDER_CAR_TYPE_NORMAL_TAXI": {
        icon: require('@/assets/icon/vehicle/taxi.png'),
        name: "出租车",
        description: "传统出租 接单快速",
        pricePrefix: "预估",
        discount: 1.0,
        checked: false
      },
      "ORDER_CAR_TYPE_ONLINE_TAXI": {
        icon: require('@/assets/icon/vehicle/taxi-new.png'),
        name: "新出租",
        description: "线上价格 超值畅行",
        pricePrefix: "预估",
        discount: 0.9,
        checked: false
      }
    });
    return {
      title,
      setting,
      isWatchSetting,
      showVehicleTypes,
      showWaitingTimeout,
      vehicleTypes
    };
  },
  watch: {
    setting: {
      handler: function () {
        if (this.isWatchSetting) {
          this.setUserSetting();
        }
      },
      deep: true
    }
  },
  mounted() {
    this.getUserSetting();
  },
  methods: {
    selectVehicleTypes(type) {
      if (this.setting.orderCarTypes[type]) {
        this.setting.orderCarTypes[type] = false;
      } else {
        this.setting.orderCarTypes[type] = true;
      }
      SettingApi.setSetting(this.setting).then(function (result) {}).finally(function () {});
    },
    selectWaitingTimeout(value) {
      this.setting.waitingTimeout = value;
      this.showWaitingTimeout = false;
    },
    getUserSetting() {
      const that = this;
      showLoadingToast({
        duration: 0,
        // overlay: true,
        forbidClick: true,
        message: '正在加载...'
      });
      SettingApi.getSetting().then(function (result) {
        if (result.setting) {
          that.setting = result.setting;
          if (that.setting && that.setting.orderCarTypes) {
            for (const key in that.setting.orderCarTypes) {
              that.vehicleTypes[key].checked = that.setting.orderCarTypes[key];
            }
          }
        }
      }).finally(function () {
        that.isWatchSetting = true;
        closeToast();
      });
    },
    setUserSetting() {
      SettingApi.setSetting(this.setting);
    }
  }
};